import { render, staticRenderFns } from "./BookingActivities.vue?vue&type=template&id=03f17d48&lang=pug&"
import script from "./BookingActivities.vue?vue&type=script&lang=ts&"
export * from "./BookingActivities.vue?vue&type=script&lang=ts&"
import style0 from "./BookingActivities.vue?vue&type=style&index=0&id=03f17d48&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports